import React from 'react'
import { Navigate, useParams } from 'react-router'
import { useQuery } from '@tanstack/react-query'
import { AppRoutes } from '@core/AppRoutes'
import { MainContainer } from '@core/Components/Containers'
import { ProfileDisplay } from '@core/Areas/BetLoop/Components/ProfileDisplay/ProfileDisplay'
import { RestrictedProfile } from '@core/Areas/BetLoop/Components/RestrictedProfile'
import { betLoopProfileByIdQuery } from '@core/Areas/BetLoop/helpers/queries'
import { isBetLoopProblemResponse } from '@core/Areas/BetLoop/helpers/api/typeGuards'

export const ProfilePage: React.FC = () => {
  const { profileId } = useParams<{ profileId: string }>()

  if (!profileId) {
    return <Navigate to={AppRoutes.BetLoop} />
  }

  return <ProfilePageComponent profileId={profileId} />
}

// ===============
// Local Component
// ===============

const ProfilePageComponent: React.FC<{ profileId: string }> = ({ profileId }) => {
  const { data, isPending, isError, error } = useQuery(betLoopProfileByIdQuery(profileId))

  if (isPending) {
    // TODO: Replace with skeleton loader
    return null
  }

  if (isError || !data) {
    if (isBetLoopProblemResponse(error) && error?.isBanned) {
      return <RestrictedProfile />
    }

    return <div>Error: No profile found</div>
  }

  return (
    <MainContainer background='surface300'>
      <ProfileDisplay isMyProfile={data.isMe} profile={data} />
    </MainContainer>
  )
}
